import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import useAuth from './useAuth';

export default function useCenterUsers() {
    const { request } = useAuth();
    const queryClient = useQueryClient();

    const centerUsersQuery = useQuery({
        queryKey: ['centerUsers'],
        queryFn: () => request.get('/center/getCenterUsers').then((res) => res.data),
    });

    const addCenterUserMutation = useMutation({
        mutationFn: (data) => request.post('/center/addCenterUser', data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['centerUsers'] });
        },
    });

    const deleteCenterUserMutation = useMutation({
        mutationFn: (id) => request.delete('/center/deleteCenterUser', { data: { id } }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['centerUsers'] });
        },
    });

    const updateProfileMutation = useMutation({
        mutationFn: (data) => request.put('/center/updateProfile', data),
    });

    const getCenterProfile = () => request.get('/center/profile').then((res) => res.data);

    return {
        centerUsers: centerUsersQuery?.data?.users || [],
        isCenterUsersLoading: centerUsersQuery.isLoading,

        addCenterUser: addCenterUserMutation.mutateAsync,
        isAddingCenterUser: addCenterUserMutation.isPending,

        deleteCenterUser: deleteCenterUserMutation.mutateAsync,
        isDeletingCenterUser: deleteCenterUserMutation.isPending,

        updateProfile: updateProfileMutation.mutateAsync,
        isUpdatingProfile: updateProfileMutation.isPending,

        getCenterProfile,
    };
}
